const values = [
  {
    icon: 'ri-heart-pulse-line',
    title: 'Compassion',
    desc: 'Every action we take is rooted in deep empathy for persons living with epilepsy and their families.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Integrity',
    desc: 'We operate with full transparency, accountability, and ethical governance in all our programs.',
  },
  {
    icon: 'ri-team-line',
    title: 'Community',
    desc: 'We believe in the power of community-led solutions tailored to local needs and cultural contexts.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Innovation',
    desc: 'We embrace creative, evidence-based approaches to tackle the complex challenges of epilepsy in Africa.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Equity',
    desc: 'We champion equal access to care, treatment, and dignity for every person regardless of background.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Sustainability',
    desc: 'Our programs are designed for lasting impact — building systems that outlive any single intervention.',
  },
];

export default function MissionVisionValues() {
  return (
    <section className="py-24 bg-[#FAF7FC]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          {/* Mission */}
          <div className="relative rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=African%20epilepsy%20awareness%20campaign%20outdoors%2C%20volunteers%20holding%20purple%20banners%2C%20diverse%20community%20members%20engaged%2C%20warm%20sunlight%2C%20hopeful%20and%20energetic%20atmosphere%2C%20wide%20shot&width=700&height=500&seq=mv01&orientation=landscape"
              alt="IKIRU Mission"
              className="w-full h-64 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D0A35]/90 via-[#2D0A35]/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#7B2D8B]/40 border border-purple-400/30 mb-3">
                <i className="ri-focus-3-line text-[#C084FC] text-xs"></i>
                <span className="text-purple-200 text-xs font-semibold uppercase tracking-widest">Mission</span>
              </div>
              <p className="text-white text-sm leading-relaxed">
                To proactively increase epilepsy awareness, facilitate effective treatment, empower communities, and advocate for transformative policies through education, partnerships, and compassionate humanitarian services.
              </p>
            </div>
          </div>

          {/* Vision */}
          <div className="relative rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=African%20children%20and%20adults%20together%20in%20a%20bright%20open%20field%2C%20joyful%20and%20free%2C%20purple%20flowers%20in%20foreground%2C%20golden%20sunlight%2C%20wide%20open%20sky%2C%20symbolic%20of%20hope%20and%20a%20better%20future%2C%20artistic%20photography&width=700&height=500&seq=mv02&orientation=landscape"
              alt="IKIRU Vision"
              className="w-full h-64 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A0A1E]/90 via-[#1A0A1E]/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#7B2D8B]/40 border border-purple-400/30 mb-3">
                <i className="ri-eye-line text-[#C084FC] text-xs"></i>
                <span className="text-purple-200 text-xs font-semibold uppercase tracking-widest">Vision</span>
              </div>
              <p className="text-white text-sm leading-relaxed">
                A society where every individual living with epilepsy enjoys full inclusion, equitable access to quality care, and lives with dignity — free from stigma. A future where understanding replaces fear.
              </p>
            </div>
          </div>
        </div>

        {/* Core Values */}
        <div className="text-center mb-4">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B]">What Guides Us</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center mb-14">
          Our Core <span className="text-[#7B2D8B]">Values</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((v, i) => (
            <div
              key={v.title}
              className="group bg-white rounded-2xl p-8 border border-purple-100 hover:border-[#7B2D8B]/40 hover:-translate-y-1 transition-all duration-200"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#7B2D8B]/10 group-hover:bg-[#7B2D8B] transition-colors duration-200">
                  <i className={`${v.icon} text-[#7B2D8B] group-hover:text-white text-xl transition-colors duration-200`}></i>
                </div>
                <span className="text-xs font-bold uppercase tracking-widest text-[#7B2D8B]/50">0{i + 1}</span>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-2">{v.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
